// extracted by mini-css-extract-plugin
export default {"imageHead":"index_imageHead_NqzYX","imageHeadTitle":"index_imageHeadTitle_JOlCo","imageHeadMore":"index_imageHeadMore_UXbQd"};